"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "../supabaseClient"
import "../styles/Login.css"

export default function Login() {
  const [email, setEmail] = useState("")
  const [senha, setSenha] = useState("")
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState("")
  const navigate = useNavigate()

  const handleLogin = async () => {
    if (!email || !senha) {
      setErro("Por favor, preencha email e senha")
      return
    }

    setLoading(true)
    setErro("")

    try {
      const { data: userData, error: userError } = await supabase
        .from("usuarios")
        .select("id, nome, email, papel, instituicao_id, ativo")
        .eq("email", email.trim().toLowerCase())
        .eq("senha", senha)
        .maybeSingle()

      if (userError) {
        throw new Error("Erro ao buscar usuário")
      }

      if (!userData) {
        throw new Error("Email ou senha incorretos")
      }

      if (!userData.ativo) {
        throw new Error("Usuário sem autorização.")
      }

      localStorage.setItem("userId", userData.id)
      localStorage.setItem("userName", userData.nome)
      localStorage.setItem("userEmail", userData.email)
      localStorage.setItem("userPapel", userData.papel)
      localStorage.setItem("instituicaoId", userData.instituicao_id || "")

      // Disparar evento para o AuthContext recarregar
      window.dispatchEvent(new CustomEvent("auth-login"))

      // Usar React Router para navegacao interna
      navigate("/dashboard")
    } catch (error) {
      setErro(error.message || "Erro ao fazer login")
      setLoading(false)
    }
  }

  // Ouvir evento de usuario bloqueado (ex: foi desativado no servidor)
  useEffect(() => {
    const onBlocked = (e) => {
      setErro(e?.detail || "Usuário sem autorização.")
    }
    window.addEventListener("auth-blocked", onBlocked)
    return () => window.removeEventListener("auth-blocked", onBlocked)
  }, [])

  const irParaRegistro = () => {
    navigate("/register")
  }

  return (
    <div className="bg-animated-login">
      <div className="login-container animate-fadeIn">
        <h2 className="login-title">CajuTime Planner</h2>
        <p style={{ textAlign: "center", marginBottom: "20px", color: "#666" }}>Sistema de Gestão de Horários</p>

        {erro && (
          <div
            style={{
              padding: "10px",
              marginBottom: "15px",
              background: "#fee",
              border: "1px solid #f00",
              borderRadius: "5px",
              color: "#c00",
              fontSize: "14px",
            }}
          >
            {erro}
          </div>
        )}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          autoComplete="email"
        />

        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          className="login-input"
          autoComplete="current-password"
          onKeyPress={(e) => e.key === "Enter" && handleLogin()}
        />

        <button onClick={handleLogin} className="login-button" disabled={loading}>
          {loading ? "Entrando..." : "Entrar"}
        </button>

        <p className="login-footer">
          Não tem uma conta?{" "}
          <span className="login-link" onClick={irParaRegistro}>
            Registrar-se
          </span>
        </p>

        <div
          style={{
            marginTop: "20px",
            padding: "15px",
            background: "#f5f5f5",
            borderRadius: "8px",
            fontSize: "13px",
            border: "1px solid #ddd",
          }}
        >
          <strong>Credenciais de teste:</strong>
          <br />
          <span style={{ color: "#333" }}>Email: admin@teste.com</span>
          <br />
          <span style={{ color: "#333" }}>Senha: admin123</span>
        </div>
      </div>
    </div>
  )
}
